const LOG_PREFIX = '[Article]';

const CODE_BLOCK_SNIPPET_LANGUAGES = [
  'javascript',
  'jsx',
  'csharp',
  'php',
  'ruby',
  'python',
  'java',
  'json',
  'c',
  'bash',
  'shell',
  'go',
  'groovy',
];

export default { LOG_PREFIX, CODE_BLOCK_SNIPPET_LANGUAGES };
